document.addEventListener('DOMContentLoaded', () => {
  const swiperContainer = document.querySelector('[data-swiper]');
  if (!swiperContainer) return;

  const tabs = document.querySelectorAll('[data-swiper-tabs] .image-with-testimonials__tab');
  const nextBtn = document.querySelector('[data-swiper-next-testimonial]');
  const images = document.querySelectorAll('.image-with-testimonials__media-image');

  const swiper = new Swiper(swiperContainer, {
    slidesPerView: 1,
    allowTouchMove: true,
    speed: 500,
    autoHeight: true,
    effect: 'slide',
    navigation: {
      nextEl: nextBtn,
    },
    on: {
      init(sw) {
        updateActiveImage(sw.activeIndex);
      },
      slideChange(sw) {
        updateActiveTab(sw.activeIndex);
        updateActiveImage(sw.activeIndex);
      },
    },
    breakpoints: {
      990: {
        autoHeight: false,
      },
    },
  });

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      swiper.slideTo(index);
      updateActiveTab(index);
      updateActiveImage(index);
    });
  });

  function updateActiveTab(activeIndex) {
    tabs.forEach((tab, idx) => {
      tab.classList.toggle('active', idx === activeIndex);
    });
  }

  function updateActiveImage(index) {
    if (!images.length) return;
    images.forEach((img) => img.classList.remove('active'));
    const target = document.querySelector(`.image-with-testimonials__media-image[data-index="${index}"]`);
    if (target) target.classList.add('active');
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => swiper.update());
    document.addEventListener('shopify:section:reorder', () => swiper.update());
    document.addEventListener('shopify:section:select', () => swiper.update());
  }
});
